// Shared presentational bits used by the admin/company "Edit User" pages.
import { CustomImage, CustomPagination, CustomCheckbox, CustomFormItem } from '@src/components';
import { Checkbox, Input, Empty } from 'antd';
import search from '@src/assets/icons/icon-transparent-search.svg';
import PropTypes from 'prop-types';

export const SearchInput = ({ id, value, placeholder, onSearch, onChange }) => (
    <Input
        id={id}
        onChange={onChange}
        onPressEnter={onSearch}
        placeholder={placeholder}
        value={value || ''}
        prefix={<CustomImage src={search} onClick={onSearch} />}
        className="custom-search-input"
    />
);

SearchInput.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

SearchInput.defaultProps = {
    id: null,
    value: null,
    placeholder: null,
};

export const VouPagination = ({ pagedProperty, onChange }) => (
    <div className="d-flex justify-content-center">
        <CustomPagination
            onChange={onChange}
            current={pagedProperty?.currentPage || 1}
            defaultCurrent={1}
            pageSize={pagedProperty?.pageSize || 1}
            total={pagedProperty?.totalItems || 1}
        />
    </div>
);

VouPagination.propTypes = {
    pagedProperty: PropTypes.shape({
        currentPage: PropTypes.number,
        pageSize: PropTypes.number,
        totalItems: PropTypes.number,
    }),
    onChange: PropTypes.func.isRequired,
};

VouPagination.defaultProps = {
    pagedProperty: {
        currentPage: 1,
        pageSize: 1,
        totalItems: 1,
    },
};

export const CheckboxFormItem = ({ formItemName, items, renderItem, emptyNode }) => (
    items?.length > 0 ? (
        <div className="u-p-2">
            <CustomFormItem label={false} className="u-p-l-3" name={formItemName}>
                <Checkbox.Group>
                    {items.map(renderItem)}
                </Checkbox.Group>
            </CustomFormItem>
        </div>
    ) : (emptyNode ?? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />)
);

CheckboxFormItem.propTypes = {
    formItemName: PropTypes.array.isRequired,
    items: PropTypes.array,
    renderItem: PropTypes.func.isRequired,
    emptyNode: PropTypes.node,
};

CheckboxFormItem.defaultProps = {
    items: [],
    emptyNode: null,
};

export const CheckboxItem = ({ id, value, label, disabled, onChange }) => (
    <div className="u-m-2">
        <CustomCheckbox
            id={id}
            value={value}
            className="collapse-header-checkbox"
            disabled={disabled}
            onChange={onChange}
        />
        <span> {label} </span>
    </div>
);

CheckboxItem.propTypes = {
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

CheckboxItem.defaultProps = {
    id: null,
    value: null,
    label: null,
    disabled: false,
};
